import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1F1E1D",
      "fill-rule": "evenodd",
      d: "M6.502 2.8H10c.295 0 .534.238.534.533V4a.8.8 0 0 0 1.6 0v-.667A2.133 2.133 0 0 0 10 1.2H3.41C2.27 1.161 1.2 2.058 1.2 3.335v7.926c0 .735.379 1.42 1.003 1.809l2.666 1.666c1.261.789 2.855.073 3.198-1.27H10a2.133 2.133 0 0 0 2.133-2.133v-.666a.8.8 0 1 0-1.6 0v.666a.533.533 0 0 1-.533.534H8.134V5.002c0-.735-.379-1.42-1.003-1.81zm-2.886.083a.533.533 0 0 0-.816.452v7.926c0 .184.095.355.25.452l2.668 1.667a.533.533 0 0 0 .816-.452V5.002a.53.53 0 0 0-.25-.452zm8.485 2.551a.8.8 0 0 1 1.131 0l1.334 1.334a.8.8 0 0 1 0 1.131l-1.334 1.333a.8.8 0 0 1-1.162-1.099H10a.8.8 0 1 1 0-1.6h2.07a.8.8 0 0 1 .031-1.099",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }